export default {
  metrics: {
    gs: {
      label: 'PL View',
      desc: 'Number of times the creative showed (replays are not counted).',
      group: 'PL View',
    },
    fi: {
      label: 'First Interaction',
      scene_label: 'Scene First Interaction',
      desc: 'The first time a user triggers a click, drag, or other interactive action is counted as a first interaction.',
      group: 'First Interaction',
    },
    ge: {
      label: 'Game End',
      desc: 'When a user reaches the end scene or meets specific end conditions, it is counted as a game end.',
      group: 'Game End',
    },
    vi: {
      label: 'Effective Interaction',
      desc: 'Number of interactive actions by users triggering game logic.',
    },
    vi_avg: {
      label: 'Average Effective Interaction',
      desc: 'The average number of user interactions with game logic per PL View.',
    },
    wc: {
      label: 'Close Creative',
      desc: 'Number of times users click the close button.',
    },
    install: {
      label: 'Redirect',
      scene_label: 'Scene Redirect',
      desc: "When users navigate to other URLs or app stores, it's counted as a redirect.",
    },
    replay: {
      label: 'Replay',
      desc: 'When a user clicks on "Replay," it\'s counted as one a replay.',
    },
    fi_time: {
      label: 'TTE',
      desc: "Average time from creative show to first interaction (excluding those who didn't interact).",
    },
    ge_time: {
      label: 'Duration of Gameplay',
      desc: "Average time from creative show to play end (excluding those who didn't complete play).",
    },
    loss: {
      label: 'Drop off from Scene',
      desc: 'Number of users who dropped off without navigating to other URLs or app stores.',
    },
    loss_after_fi: {
      label: 'Drop off after Interaction',
      scene_label: 'Drop off after Scene Interaction',
      desc: 'Number of users who dropped off without navigating to other URLs or app stores after Interaction.',
    },
    loss_playing: {
      label: 'Drop off during Gameplay',
      desc: 'Number of users who dropped off without navigating to other URLs or app stores during gameplay.',
    },
    loss_ending: {
      label: 'Drop off after Gameplay',
      desc: 'Number of users who dropped off without navigating to other URLs or app stores after gameplay.',
    },
    loss_fi: {
      label: 'Drop off before Gameplay',
      scene_label: 'Drop off before Scene Interaction',
      desc: 'Count of users who dropped off before initiating any interactive actions.',
    },
    loss_rate: {
      label: 'Scene Drop Rate',
      desc: 'Drop off from Scene / Scene Session',
    },
    loss_fi_rate: {
      label: 'Drop Rate before Interaction',
      desc: 'Drop off before Interaction / PL View',
      scene_label: 'Drop Rate before Scene Interaction',
      scene_desc: 'Drop off before Scene Interaction / Scene Session',
    },
    loss_after_fi_rate: {
      label: 'Drop Rate after Interaction',
      desc: 'Drop after Interaction / PL View',
      scene_label: 'Drop Rate after Scene Interaction',
      scene_desc: 'Drop off after Scene Interaction / Scene Session',
    },
    loss_playing_rate: {
      label: 'Drop Rate during Gameplay',
      desc: 'Drop off during Gameplay / PL View',
    },
    loss_ending_rate: {
      label: 'Drop Rate after Gameplay',
      desc: 'Drop off after Gameplay / PL View',
    },
    install_rate: {
      label: 'Redirect Rate',
      desc: 'Redirect / PL View',
      scene_label: 'Scene Redirect Rate',
      scene_desc: 'Scene Redirect / Scene Session',
    },
    install_playing_rate: {
      label: 'Redirect Rate during Gameplay',
      desc: 'Redirect during Gameplay / PL View',
    },
    install_ending_rate: {
      label: 'Redirect Rate after Gameplay',
      desc: 'Redirect after Gameplay / PL View',
    },
    fi_rate: {
      label: 'First Interaction Rate',
      desc: 'First Interaction / PL View',
      scene_label: 'First Interaction Rate',
      scene_desc: 'Scene First Interaction / Scene Session',
    },
    ge_rate: {
      label: 'Game End Rate',
      desc: 'Game End / PL View',
    },
    rp_rate: {
      label: 'Replay Rate',
      desc: 'Replay / PL View',
    },
    reach: {
      label: 'Scene Session',
      desc: 'Number of times users arrived the current scene.',
    },
    go_next: {
      label: 'Redirect to Another Scene',
      desc: 'Number of times users redirected from the current scene to another scene.',
    },
    go_next_rate: {
      label: 'Rate of Redirection to Another Scene',
      desc: 'Redirect to Another Scene / Scene Session',
    },
    stay_time: {
      label: 'Scene Duration',
      desc: 'Average time of user stay in this scene (excluding those who have not navigated).',
    },
    install_playing: {
      label: 'Redirection during Gameplay',
      desc: 'Number of times users navigate to other URLs or app stores during gameplay.',
    },
    install_ending: {
      label: 'Redirection after Gameplay',
      desc: 'Number of times users navigate to other URLs or app stores after gameplay.',
    },
    ge_auto: {
      label: 'Auto Game End',
      desc: 'Automatically triggered ending times due to creative or platform logic, not initiated by user interaction.',
    },
    ge_manual: {
      label: 'Manual Game End',
      desc: 'Number of times the ending was manually triggered by the user.',
    },
    install_auto: {
      label: 'Auto Redirect',
      desc: 'Number of redirects initiated automatic by creative or platform logic, not initiated by user interaction.',
    },
    install_manual: {
      label: 'Manual Redirect',
      desc: 'Number of redirects initiated manually by the user.',
    },
    title: 'Metrics',
  },
  metricsType: {
    action: 'Interaction Metrics',
    translate: 'Conversion Metrics',
    loss: 'Drop off Metrics',
    custom: 'Custom Tracking Metric',
    placeAds: 'Ad Performance Metrics',
  },
  metricsGroupType: {
    ads: 'Ad Performance',
    pl: 'Interaction Data',
  },
  adsMetrics: {
    cost: {
      label: 'Cost',
    },
    click: {
      label: 'Click',
    },
    impression: {
      label: 'Impression',
    },
    install: {
      label: 'Conversion',
    },
    ctr: {
      label: 'CTR',
      desc: 'Click / Impression',
    },
    cvr: {
      label: 'CVR',
      desc: 'Conversion / Click',
    },
    ivr: {
      label: 'IVR',
      desc: 'Conversion / Impression',
    },
    cpi: {
      label: 'CPI',
      desc: 'Cost / Conversion',
    },
    cpm: {
      label: 'CPM',
      desc: 'Cost / (Impression * 1000)',
    },
    cpc: {
      label: 'CPC',
      desc: 'Cost / Click',
    },
    date_cost: {
      label: 'Daily Ads Cost',
    },
    date_impression: {
      label: 'Daily Impression',
    },
    date_click: {
      label: 'Daily Click',
    },
    date_install: {
      label: 'Daily Conversion',
    },
  },
  breakdowns: {
    ad_output_type: 'Ad output type',
    material_name: 'Network Creative Name',
    material_type: 'Creative Type',
    package_name: 'Distribution Product',
    material_source: 'Creative Source',
    template_id: 'Playable Templates',
    campaign_id: 'Campaign',
    adset_id: 'Ad Sets',
    basic_id: 'Creative ID and Name',
    fingerprint: 'Playturbo Creative Name and Fingerprint',
    fingerprint_desc:
      'When some creatives do not have a Playturbo creative name, the Network creative name will be used for display. If there is no Network creative name, the creative fingerprint will be used for display.',
    ad_id: 'Ads',
    period: 'Date',
    traffic_type: 'Network',
    platform: 'OS',
    country_code: 'Distribution Area',
    project_id: 'Project Name and ID',
    ad_type: 'Ad Type',
    mid: 'Creative ID',
    product_id: 'Associate with Product',
    publish_time: 'Generated Time',
    scene: 'Scene',
    title: 'Dimensions',
    onlyMintegralTip:
      'This option is only available when the network is Mintegral.',
    onlyUnityTip: 'This option is only available when the network is Unity.',
    tooltipAdDataTips: {
      datarange:
        'Bind the advertising account and ensure that the scope of playable data is not set to "Not Fetch."',
      mars: 'Allow the addition of tracking events for playable.',
    },
    onlyIronsourceTip: {
      noSupport: 'Ironsource is currently not supported',
    },
  },
  title: 'Creative Insights',
  overview: {
    title: 'Overview (Beta)',
    desc: 'This page provides you with an overview of the Ad Performance for your ad accounts. You can quickly understand the performance of various ad accounts and different types of creative materials.',
    data: {
      title: 'Data for the Last 7 Days',
      account: 'Account',
      accountAll: 'All',
      accountBtn: 'Edit Associated Advertisers',
      adData: 'Ad Performance',
      plData: 'Creative Data',
      impression: 'Creatives with Non-Zero Impressions',
      impressionTips:
        'Number of materials with impressions greater than 0 in the past 7 days',
      minimumQuantity: 'Creatives with High Impressions',
      minimumQuantityTips:
        'Number of materials with impressions greater than 3000 in the past 7 days',
    },
    chart: {
      title: 'Comparative Analysis',
      detailTitle: 'Detailed Data',
      detailTooltip:
        'When an ad contains multiple creatives, the number of impressions, clicks, installs, and costs will be counted for each creative.',
    },
    single: {
      title: 'Individual product creative situation',
    },
    overall: {
      title: 'Overall creative situation',
      subTitle: {
        all: 'Based on "Creative" dimension, charts include Playturbo\'s playable materials.',
        mtg: 'Based on "Ad Creative" dimension, charts include all playables in the advertising account.',
      },
      tooltips: {
        all: 'For analyzing all materials within the advertising account, please go to individual channels.',
      },
    },
    material: {
      source: {
        title: 'Comparison of creative sources',
      },
      pv: {
        title: 'Creative volume situation',
      },
      install: {
        title: 'Creative conversion situation',
      },
      pl: {
        title: 'Creative situation',
      },
      alldata: {
        title: 'All data',
      },
    },
  },
  tips: {
    materialTypeDisabled:
      'View this dimension after filtering by material type.',
    selectedReason:
      "Current dimension doesn't support this metric. Please choose again.",
    filteredReason:
      "Current filter doesn't support this metric. Please choose again.",
    daterange: {
      max: 'Selected date exceeds the specified maximum of {max} days.',
    },
  },
  chart: {
    breakdown: {
      ruleTips:
        'Maximum of 1 dimension allowed. Please go to the custom report to make changes.',
    },
    filter: {
      day: {
        label: 'By Day',
        desc: 'Daily Summary',
      },
      week: {
        label: 'By Week',
        desc: 'Weekly Summary',
      },
      month: {
        label: 'By Month',
        desc: 'Monthly Summary',
      },
    },
    exceedTip:
      '* Aggregate metric data for the current period, display the top {max} in descending order.',
  },
  tz: {
    label: 'Time Zone',
    all: {
      tip: 'Different networks have different time zones, {text}',
      tipBtnText: 'Click to View Details',
    },
    mtg: {
      tip: 'Follows the time zone of the main account',
    },
    updateTime: 'Updated Time',
    updateTimeTip: '{time} Updated data for the previous day.',
  },
  material: {
    title: 'PL Performance',
    dataAnalysis: {
      title: 'Detailed Data',
      filterDialog: {
        btnText: 'Custom Reports',
        filter: 'Filters',
        column: 'Custom Columns',
      },
    },
    detailTitle: 'PL Interaction Analysis',
    detailTitleDesc:
      'Analyze user session, drop, and conversion in different scenes and custom trackings.',
    analyze: {
      tab: {
        scene: 'Scene Analysis',
        journey: 'User Journey Analysis',
      },
      projectType: {
        subs: 'Subscription Projects',
        custom: 'Customized Projects',
      },
    },
    DetailData: 'Detailed Data',
    playable: {
      description:
        'Based on the Ad Performance and tracking data of playable materials, we provide you with multidimensional analysis. Through these data, you can gain insights into user behavior, evaluate the effectiveness of the materials, and provide a basis for further material optimization.',
      interaction: {
        description:
          'Based on the tracking data of playable materials, we offer you an analysis of user interactions from the dimensions of user journey and scenarios. You can use this data to identify potential optimization points for your materials.',
      },
    },
    descriptionTooltip:
      'The data is provided for reference and analyze user interactions. It does not represent final results.',
    descTip:
      'The data is provided for reference and analyze user interactions. It does not represent final results.',
    unsupportAnalyze: {
      noaccess: 'No Permission',
      noscene:
        'The creative is not differentiated by scenes and does not support analysis.',
    },
    projectFilter: {
      select: 'Please select',
      empty: 'Creative version not selected yet',
    },
    preview: {
      title: 'Preview',
      selectText: 'Start Preview',
      sceneName: 'Scene {n}',
      sceneFrom: 'Start Preview from Scene {n}',
      sceneDlLoss: 'Scene Distribution',
    },
  },
  event: {
    title: 'Event Analysis',
    desc: 'Collect user interactions during gameplay And provide analysis in multiple dimensions and charts.',
    descTip:
      'The data is provided for reference and analyze user interactions. It does not represent final results.',
    overview: {
      title: 'Data for the Last 7 Days',
      subTitle: 'Assets in this period: {count}',
      fi_time_average: 'TTE',
      ge_time_average: 'Duration of Gameplay',
      ge_manual_rate: 'End Rate after Interaction',
      adsData: 'Ad Performance',
      adsDataTips: {
        all: 'Aggregate delivery data of playable across all authorized advertising accounts.',
        mtg: 'Aggregate the delivery data of playable under the {trafficType} authorized advertising accounts.',
      },
      plData: 'User Interaction',
      plDataTips: {
        all: 'Aggregate the interactive data of all playable produced by the Playturbo account.',
        mtg: 'Aggregate the interactive data of {trafficType} playable produced by the Playturbo account.',
        other:
          'Summary of interactive data for all playable materials produced by this Playturbo account and delivered through this channel.',
      },
    },
    trend: {
      title: 'Trend Analysis',
      subTitle: 'The trend of selected metrics within a specified time period.',
      unknown: 'Unknown',
      topTips:
        'Sort and display aggregated data metrics in descending order for this period.',
      filterDialog: {
        btnText: 'Custom Charts',
        filter: 'Filters',
        mab: 'Metric Dimensions',
      },
    },
    detail: 'Detailed Data',
  },
  customColumn: {
    title: 'Columns',
    placeholder: 'Search',
    materialRule: 'Please select at least {num} creative info.',
    metricsRule: 'Please select at least {num} metrics.',
    breakdownRule: 'Please select at least {num} dimensions.',
    breakdownsRule: 'Please select {min}-{max} dimensions.',
    materialInfo: 'Creative Info',
    materialInfoProduct: 'Creative Production Info',
    materialInfoPoint: 'Creative Delivery Info',
    selected: 'Select {count}',
    clear: 'Clear',
    emptyData: 'No Data',
    fixedMessage: 'Drag to fix the columns at the top.',
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  export: {
    title: 'Export',
    message: 'Exporting may take some time, please wait.',
    error: 'Export failed, please try again.',
  },
  blankTemplate: 'Blank Canvas',
  filter: {
    productNameOrId: 'Project Name and ID',
    product_id: 'Project ID',
    product_name: 'Project Name',
    pleaseInput: 'Please enter',
    search: 'Search',
    inputProductId: 'Please enter the associated product',
    publish_time: 'Creative Creation Time',
    pleaseSelect: 'Please select',
    showTime: {
      first: 'Fist Session',
      all: 'Sum of all Session Counts',
    },
    adType: {
      rewardedVideo: 'Rewarded Video',
      interstitialVideo: 'Interstitial Video',
    },
    platform: {
      ios: 'iOS',
      android: 'Android',
    },
    adOutputType: {
      videoAndCommonEndcard: 'Video + Standard Endcard',
      videoAndDynamicEndcard: 'Video + Dynamic Endcard',
      videoAndPlayable: 'Video + Playable',
      onlyVideo: 'Video Only',
      onlyPlayable: 'Playable Only',
      other: 'Others',
    },
    trafficType: {
      all: 'All',
    },
    materialType: {
      pl: 'Playable',
      video: 'Video',
      graphic: 'Images',
      unknown: 'Unknown',
    },
    materialSource: {
      playturboTemplate: 'Playturbo Feature Changer',
      playsmart: 'Playturbo Content Editor',
      mws: 'MWS Customization',
      adPlatform: 'Network Upload',
      unknown: 'Unknown',
    },
    total: {
      filters: 'Filters',
      columns: 'Column',
    },
  },
  table: {
    operation: 'Operations',
  },
  searchFilter: {
    clear: 'Clear',
    allFilter: 'Filters',
    filter: 'Filters',
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  ringRatio: 'Week-on-Week {value}',
  journey: {
    title: 'User Journey Analysis',
    filter: {
      label: 'All Filters',
    },
    actions: {
      cancel: 'Cancel',
      save: 'Display Journey',
      edit: 'Edit',
    },
    disabledEditTips:
      'This comes from template or customization, so there is no need for manual configuration.',
  },
  searchEmpty: {
    tips: 'No search results found.',
  },
  searchForbidden: {
    tips: 'Selectable after clearing the search content.',
  },
}
